module.exports = __webpack_public_path__ + "img/lock.0757ea0e.svg";